import React,{ useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import Star from '../../components/Star/Star';
import ChartBarDom from '../../components/ChartBarDom/ChartBarDom'
import BigCard from '../../components/BigCard/BigCard';
import Reviews from '../../components/Reviews/Reviews';
import Questions from '../../components/Questions/Questions';
import ImgTimeLine from '../../components/ImgTimeLine/ImgTimeLine';

import ModuleLoader from '../../components/ModuleLoader';
import {
  communityData,
  AutoSwitchingData,
  recommend_goodsData,
  goodsCarouselData,
  articleCarouselData,
  imgCardData,
  imgCardData_icon,
  bgCardData,
  dbCard,
  dbImg_leftContent_CardList,
  PhotoWallData,
  productDescriptionData,
  questionsData,
  ImgTimeLineData,
} from '../../components/AnalogData'

import Energy_Black from '../../image/Energy1-black-40x40.svg'
import Strength_Black from '../../image/Strength-black-40x40.svg'
import Endurance_Black from '../../image/Endurance-black-40x40.svg'
import OptimalLevels_Black from '../../image/Optimal-levels-black-40x40.svg'

import { getProductList, getProductInfo } from '../../api/goods'
import { getBlogList } from '../../api/article'

import './shopDetail.less';

const ShopDetail = () =>{
  const location = useLocation();
  const shopImgBoxRef = useRef(null)
  const shopDetailBoxRef = useRef(null)

  const [width, setWidth] = useState(window.innerWidth);
  const [topH, setTopH] = useState(0)
  const [selectPrice, setSelectPrice] = useState('1')


  const priceObj = {
    price: '125',
    discount: [{
      num: '1',
      discount:'0.1'
    },{
      num: '2',
      discount:'0.2'
    },{
      num: '4',
      discount:'0.24'
    },{
      num: '12',
      discount:'0.32'
    }]
  }

  let textStyle = {
    titleSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)',
    descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)'
  }
  const [goodsData, setGoodsData] = useState({
    title: 'Mitopure Softgels',
    description: 'Improve your cellular health by taking Mitopure in its simplest form with two vegan softgels daily for the recommended dose of Urolithin A (500mg of Mitopure). Each sachet contains 60 softgels, which will last you a month.',
    img: require('../../image/shop1-1200x1200.avif'),
    viewMatrix: [],
    feature: [],
    priceData: {
      price: '100',
      discount: []
    },
    prodInfoPagePath2: [],
    // star: 4.4,
    // commentCount: 2813,
    bestseller: false,
    tag: false
  })
  
  let [goodsList, setGoodsList] = useState(goodsCarouselData)
  let [articleList, setArticleList] = useState(articleCarouselData)
  let [recommendGoods, setRecommendGoods] = useState(recommend_goodsData)


  /* 获取商品信息 */ 
  const getProductInfoFn = async (id) =>{
    let res = await getProductInfo(id)
    if(res.msg === 'success'){
      let priceArr = []
      Object.entries(res?.data).forEach(e=>{
        if(e[0].indexOf('realPrice') > -1){
          priceObj.discount.forEach((E)=>{
            if(`realPrice${E.num}mo` === e[0]){
              priceArr.push({
                num: E.num,
                discount: Math.round(100 - (e[1] / res?.data[`price${E.num}mo`])*100)/100,
                price: res?.data[`price${E.num}mo`],
                realPrice: res?.data[`realPrice${E.num}mo`],
              })
            }
          })
        }
      })
      console.log(priceArr)
      setGoodsData({
        title: res?.data.prodName,
        description: res?.data.description,
        img: res?.data.prodImg1,
        viewMatrix: res?.data.viewMatrix.split(';'),
        prodInfoImg: res?.data.prodInfoImg?.split(';'),
        feature: res?.data.feature.split(';'),
        priceData: {
          price: res?.data.price1mo,
          discount: priceArr
        },
        prodType: res?.data.prodType,
        prodInfoPagePath2: res?.data.prodInfoPagePath2?.split(';'),
        // star: 4.4,
        // commentCount: 2813,
        bestseller: false,
        tag: false
      })
    }
  }
  // 获取商品列表
  const getProductListFn = async () =>{
    let update = {
      page: 1,
      limit: 100,
      prodType: goodsData.prodType,
      prodStatus: '1',
    }
    let res = await getProductList(update)
    console.log(res)
    if(res?.msg === 'success'){
      let data = res?.data.map((e,i)=>{
        if(i===0){
          setRecommendGoods(()=>{
            return {
              id: e.id,
              title: e.prodName,
              description: e.description,
              img: e.prodImg1,
              imgHover: e.prodImg2,
              // star: 4.4,
              // commentCount: 2813,
              bestseller: false,
              tag: false
            }
          })
        }
        return ({
          type: 'goods',
          content:{
            title: e.prodName,
            description: e.description,
            img: e.prodImg1,
            imgHover: e.prodImg2,
            // star: 4.4,
            // commentCount: 2813,
            bestseller: false,
            tag: false
          },
          btnConfig:{
            link:`/shopDetail?id=${e.id}`,
          }
        })
      })
      console.log(data)
      let copyData = JSON.parse(JSON.stringify(goodsList))
      copyData.data = data
      setGoodsList(()=> copyData)
    }
  }
  // 获取论文列表
  const getBlogListFn = async () =>{
    let update = {
      page: 1,
      limit: 100,
      status: 1,
      // categoryType: 1
    }
    let res = await getBlogList(update)
    console.log('BlogList', res?.data)
    if(res?.msg === 'success'){
      let data = res?.data.map((e,i)=>{
        // console.log(e)
        const now = new Date(e.publishedTime);
        const Y = now.getFullYear();
        const M = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
        const D = String(now.getDate()).padStart(2, '0');
        const h = String(now.getHours()).padStart(2, '0');
        const m = String(now.getMinutes()).padStart(2, '0');
        const s = String(now.getSeconds()).padStart(2, '0');

        return {
          type: 'img2',
          content: {
            // img: <img src={e.coverImage} style={{width: '100%',borderRadius:5}}/>,
            img: <div style={{width: '100%',height:'20vh',background: `url(${e.coverImage}) no-repeat center center/cover`}}></div>,
            title: e.title,
            // taglist: ['News', 'Nutrition','Studies'],
            time: `${Y}-${M}-${D} ${h}:${m}:${s}`
          },
          btnConfig: {
            link: e.articleUrl? e.articleUrl:`/aBoutDetail?id=${e.id}`,
            linkType: e.articleUrl? '_blank':''
          }
        }
      })
      console.log(data)
      let copyData = JSON.parse(JSON.stringify(articleList))
      copyData.data = data
      setArticleList(()=> copyData)
    }
  }

  useEffect(()=>{
    console.log(location.search)
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');
    if(id){
      getProductInfoFn(id)
    }
    if(shopImgBoxRef.current){
      setTimeout(()=>{
        let shopImgBoxRefH = shopImgBoxRef.current.offsetHeight
        let shopDetailBoxRefH = shopDetailBoxRef.current.offsetHeight
        if(shopDetailBoxRefH >= shopImgBoxRefH){
          setTopH(shopDetailBoxRefH)
        }else{
          setTopH(shopImgBoxRefH)
        }
      }, 300)
    }
  },[location.search])

  useEffect(()=>{
    if(shopImgBoxRef.current){
      getBlogListFn()
      
      const handleResize = () => {
        let shopImgBoxRefH = shopImgBoxRef.current.offsetHeight
        let shopDetailBoxRefH = shopDetailBoxRef.current.offsetHeight

        if(shopDetailBoxRefH >= shopImgBoxRefH){
          setTopH(shopDetailBoxRefH)
        }else{
          setTopH(shopImgBoxRefH)
        }

        setWidth(window.innerWidth);
      };
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      }
    }
  },[])

  // 推荐同类商品
  useEffect(()=>{
    if(goodsData.prodType){
      getProductListFn()
    }
  },[goodsData.prodType])
  
  return (
    <div className="shopDetail-page">
      {/* 商品详情 */}
      {width > 770?
        <div className="bigGoods-box" style={{height: topH}}>
          <div className="bigGoods-box1">
            <div className="bigGoods-box-left-box" ref={shopImgBoxRef}>
              <div className="card-goods-img-box">
                {goodsData.tag? 
                  <div className="tag-box">
                    <div className="text1">#1</div>
                    <div>
                      <div className="text2">Doctor Recommended</div>
                      <div className="text3">Urolithin A Brand</div>
                    </div>
                  </div>
                  :
                  ''
                }
                <img style={{width:'100%'}} src={goodsData.img} alt=""/>
              </div>
              <Row gutter={[16, 16]}>
                {goodsData.viewMatrix?.map((e,i)=>{
                  return (
                    <Col span={8} key={i}>
                      <img style={{width:'100%'}} src={e} alt=""/>
                    </Col>
                  )
                })}
              </Row>
            </div>
            
            <div className="bigGoods-detail-box">
              <div className="bigGoods-detail" ref={shopDetailBoxRef}>
                {goodsData.bestseller? <div className="card-Bestseller">Bestseller</div>:''}
                <span style={{fontSize: textStyle.titleSize, fontWeight: 700, margin:'16px 0 24px'}}>{goodsData.title}</span>
                {/* <div style={{display:'flex', alignItem:'center',lineHeight:'22px', marginBottom: 16}}>
                  <Star score={goodsData.star}/>
                  {goodsData.star} · {goodsData.commentCount}reviews
                </div> */}
                <div style={{fontSize: textStyle.descriptionSize, color:'rgba(0, 0, 0, 0.54)'}}>{goodsData.description}</div>
                
                <div className="tag-list">
                  {goodsData.feature?.map((e,i)=>{
                    return (<div key={i}>{e}</div>)
                  })}
                </div>

                {/* 价格 */}
                {/* <div className="price-box">
                  Subscribe & Save:
                  {goodsData.priceData?.discount?.map((e)=>{
                    return (
                      <div 
                        key={e.num} 
                        className={selectPrice === e.num? "price-item price-item-select" : "price-item"}
                        onClick={()=> setSelectPrice(e.num)}  
                      >
                        <div className="price-item-top">
                          <div className="price-item-left">
                            <div className="price-item-radio"></div>
                            <div className="price-item-numBox">
                              <div>{e.num} 份</div>
                              <div>折扣 {e.discount*100}%</div>
                            </div>
                          </div>
                          <div className="price-item-priceBox">
                            <div>
                              <span className="old-price">￥{e.price}</span>
                              ￥{e.realPrice}
                            </div>
                            <div>￥{Math.round((e.realPrice / e.num) * 100) / 100}/份</div>
                          </div>
                        </div>
                        {selectPrice === e.num?
                          <div className="price-item-bottom">
                            <div>{e.num} 份 supply delivered {e.num === '1'? 'monthly': `every ${e.num} months`}</div>
                            <div>Pause or cancel at any time</div>
                          </div>
                          :
                          ''
                        }
                      </div>
                    )
                  })}
                </div> */}

                {/* <div className="buy-btn">购 买</div>
                <div className="notes">
                  国内免费送货 
                  <span style={{margin: '0 5px'}}>·</span> 
                  <span style={{borderBottom: '1px solid #272724', cursor: 'pointer'}}>国际航运</span>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        :
        <div className="bigGoods-box-phone">
          <div className="bigGoods-box1">
            <div className="bigGoods-box-left-box" ref={shopImgBoxRef}>
              <div className="card-goods-img-box">
                {goodsData.tag? 
                  <div className="tag-box">
                    <div className="text1">#1</div>
                    <div>
                      <div className="text2">Doctor Recommended</div>
                      <div className="text3">Urolithin A Brand</div>
                    </div>
                  </div>
                  :
                  ''
                }
                <img style={{width:'100%'}} src={goodsData.img} alt=""/>
              </div>
              <Row gutter={[16, 16]}>
                {goodsData.viewMatrix?.map((e,i)=>{
                  return (
                    <Col span={12} key={i}>
                      <img style={{width:'100%'}} src={e} alt=""/>
                    </Col>
                  )
                })}
              </Row>
            </div>
            
            <div className="bigGoods-detail-box">
              <div className="bigGoods-detail" ref={shopDetailBoxRef}>
                {goodsData.bestseller? <div className="card-Bestseller">Bestseller</div>:''}
                <span style={{fontSize: textStyle.titleSize, fontWeight: 700, margin:'16px 0 24px'}}>{goodsData.title}</span>
                {/* <div style={{display:'flex', alignItem:'center',lineHeight:'22px', marginBottom: 16}}>
                  <Star score={goodsData.star}/>
                  {goodsData.star} · {goodsData.commentCount}reviews
                </div> */}
                <div style={{fontSize: textStyle.descriptionSize, color:'rgba(0, 0, 0, 0.54)'}}>{goodsData.description}</div>
                
                <div className="tag-list">
                  {goodsData.feature?.map((e,i)=>{
                    return (<div key={i} style={{padding:'5px 0'}}>{e}</div>)
                  })}
                </div>

                {/* 价格 */}
                <div className="price-box">
                  Subscribe & Save:
                  {goodsData.priceData?.discount?.map((e)=>{
                    return (
                      <div 
                        key={e.num} 
                        className={selectPrice === e.num? "price-item price-item-select" : "price-item"}
                        onClick={()=> setSelectPrice(e.num)}  
                      >
                        <div className="price-item-top">
                          <div className="price-item-left">
                            <div className="price-item-radio"></div>
                            <div className="price-item-numBox">
                              <div>{e.num} 份</div>
                              <div>折扣 {e.discount*100}%</div>
                            </div>
                          </div>
                          <div className="price-item-priceBox">
                            <div>
                              <span className="old-price">￥{e.price}</span>
                              ￥{e.realPrice}
                            </div>
                            <div>￥{Math.round((e.realPrice / e.num) * 100) / 100}/份</div>
                          </div>
                        </div>
                        {/* {selectPrice === e.num?
                          <div className="price-item-bottom">
                            <div>{e.num}-month supply delivered {e.num === '1'? 'monthly': `every ${e.num} months`}</div>
                            <div>Pause or cancel at any time</div>
                          </div>
                          :
                          ''
                        } */}
                      </div>
                    )
                  })}
                </div>

                <div className="buy-btn">购 买</div>
                <div className="notes">
                  国内免费送货 
                  <span style={{margin: '0 5px'}}>·</span> 
                  <span style={{borderBottom: '1px solid #272724', cursor: 'pointer'}}>国际航运</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      
      {/* 产品介绍 */}
      <div className="product-introduction" >
        {goodsData.prodInfoPagePath2?.map((e,i)=>{
          // console.log(e)
          if(e === 'community'){
            return <ModuleLoader key={i} moduleType={e} moduleData={communityData}/>
          }else if(e === 'auto_switching'){
            return <ModuleLoader key={i} moduleType={e} moduleData={AutoSwitchingData}/>
          }else if(e === 'recommend_goods'){
            return <ModuleLoader key={i} moduleType={e} moduleData={recommendGoods}/>
          }else if(e === 'carousel_goods'){
            return <ModuleLoader key={i} moduleType={e} moduleData={goodsList}/>
          }else if(e === 'carousel_article'){
            return <ModuleLoader key={i} moduleType={e} moduleData={articleList}/>
          }else if(e === 'card_img_left' || e === 'card_img_right'){
            return <ModuleLoader key={i} moduleType={e} moduleData={imgCardData}/>
          }else if(e === 'card_img_left_icon' || e === 'card_img_right_icon'){
            return <ModuleLoader key={i} moduleType={e} moduleData={imgCardData_icon}/>
          }else if(e === 'card_bg_leftContent' || e === 'card_bg_rightContent'){
            return <ModuleLoader key={i} moduleType={e} moduleData={bgCardData}/>
          }else if(e === 'model_dbImg'){
            return <ModuleLoader key={i} moduleType={e} moduleData={dbCard}/>
          }else if(e === 'model_dbImg_leftContent'){
            return <ModuleLoader key={i} moduleType={e} moduleData={dbImg_leftContent_CardList}/>
          }else if(e === 'photo_wall' || e === 'photo_wall_drawer'){
            return <ModuleLoader key={i} moduleType={e} moduleData={PhotoWallData}/>
          }else if(e === 'model_description'){
            return <ModuleLoader key={i} moduleType={e} moduleData={productDescriptionData}/>
          }else if(e === 'Q_A'){
            return <ModuleLoader key={i} moduleType={e} moduleData={questionsData}/>
          }else if(e === 'img_timeLine'){
            return <ModuleLoader key={i} moduleType={e} moduleData={ImgTimeLineData}/>
          }else{
            return <ModuleLoader key={i} moduleType={e}/>
          }

        })}

        <div style={width > 770? {width: '50%', margin:'0 auto'}:{width: '90%', margin:'0 auto'}}>
          {goodsData.prodInfoImg?.map((e,i)=>{
            return (
              <img style={{width:'100%'}} key={i} src={e} alt=""/>
            )
          })}
        </div>

      </div>
    </div>
  )
}

export default ShopDetail